import PageKey from 'config/PageKey';

import { IClientAlertFilterConfig, IClientAlertSortConfig } from 'models/api';
import { IClientAlert, IClientAlertData } from 'models/clientAlert';
import { ICommonTranslation, IJobsPageTranslation } from 'models/translation';

import defaultsWithFallback from 'helpers/defaultsWithFallback';
import { ListItemTranslator } from 'helpers/translationHelpers';
import { fallbackTranslation } from 'services/api/fallbackData';
import { IConverter } from 'services/api/types';

import { IFilterValues } from 'components/ClientAlertsFilterControl/ClientAlertsFilterControl';

import { IClientAlertsPageTexts } from './ClientAlertsPage';

export const readUnreadButtonOptions = {
  markAsRead: 'markAsRead',
  markAsUnread: 'markAsUnread',
};

export enum ClientAlertSortingType {
  SenderNameAsc = 'senderNameAscending',
  SenderNameDesc = 'senderNameDescending',
  DateSentAsc = 'dateSentOldest',
  DateSentDesc = 'dateSentNewest',
  ClosesAsc = 'closesAscending',
  ClosesDesc = 'closesDescending',
}

export const sortingOptionsToSortFilterMapping: Record<ClientAlertSortingType, IClientAlertSortConfig> = {
  [ClientAlertSortingType.SenderNameAsc]: {
    name: 'senderName',
    order: 'asc',
  },
  [ClientAlertSortingType.SenderNameDesc]: {
    name: 'senderName',
    order: 'desc',
  },
  [ClientAlertSortingType.DateSentAsc]: {
    name: 'alertSentDate',
    order: 'asc',
  },
  [ClientAlertSortingType.DateSentDesc]: {
    name: 'alertSentDate',
    order: 'desc',
  },
  [ClientAlertSortingType.ClosesAsc]: {
    name: 'breakdownClosingDate',
    order: 'asc',
  },
  [ClientAlertSortingType.ClosesDesc]: {
    name: 'breakdownClosingDate',
    order: 'desc',
  },
};

export function prepareClientAlertsTexts(
  pageTranslation: IJobsPageTranslation,
  commonTranslation: ICommonTranslation
): IClientAlertsPageTexts {
  const pageShared = defaultsWithFallback(pageTranslation?.shared, fallbackTranslation[PageKey.Jobs].shared);
  const agent = defaultsWithFallback(pageTranslation?.agent, fallbackTranslation[PageKey.Jobs].agent);
  const breakdown = defaultsWithFallback(commonTranslation?.breakdowns, fallbackTranslation.common.breakdowns);
  const grid = defaultsWithFallback(commonTranslation?.grid, fallbackTranslation.common.grid);

  const readUnreadOptionTranslator = new ListItemTranslator(
    grid.readUnreadButtonOptions,
    fallbackTranslation.common.grid.readUnreadButtonOptions
  );

  return {
    markAsReadAlertsLabel: readUnreadOptionTranslator.get(readUnreadButtonOptions.markAsRead),
    markAsUnreadAlertsLabel: readUnreadOptionTranslator.get(readUnreadButtonOptions.markAsUnread),
    resultStats: grid.resultStats,
    selectAllAlertsLabel: grid.selectAll,
    searchPlaceholder: agent.agentClientAlertsSearchPlaceholder,
    filterDateFilter: pageShared.filterDateFilter,
    clientAlertTitleNudge: agent.agentClientAlertsNudgedTitle,
    clientAlertTitleSuggestion: agent.agentClientAlertsSubmittedTitle,
    sentOnFormat: breakdown.sentOnFormat,
    dateTimeFormat: breakdown.dateTimeFormat,
    closingDateLabels: breakdown.closingDateLabels,
    suggested: pageShared.suggestedLabel,
    nudged: pageShared.nudgedLabel,
  };
}

export function getFilteringOptionsFomFilterValues(filterValues?: IFilterValues): IClientAlertFilterConfig | undefined {
  const dateValue = filterValues?.DateValue;

  return dateValue
    ? {
        dateSentFrom: dateValue[0].toISOString(),
        dateSentTo: dateValue[1].toISOString(),
      }
    : undefined;
}

export const clientAlertConverter: IConverter<IClientAlertData[], IClientAlert[]> = {
  convert(items) {
    return items.map((item) => ({
      ...item,
      id: `${item.alertType}__${item.id}`,
    }));
  },
};
